import React from "react";
import axios from "axios";

// const BASE_URL =
//   "https://my-json-server.typicode.com/lhmisho/jsonserver/themeOnePromoSection";

class PromoSection extends React.Component {
  state = {
    data: [
      {
        id: 1,
        heading: "Upload PSD File",
        content:
          "After uploading a PSD file, all cliparts will be automatically matched",
        iconClass: "ti-cloud-up",
      },
      {
        id: 2,
        heading: "Template Library",
        content:
          "Allows you to create many options within 2 seconds. You can use the available data in the various niches such as dog or cat ",
        iconClass: "ti-gallery",
      },
      {
        id: 3,
        heading: "Duplicate Product",
        content:
          "Duplicate campaigns help you launch many campaigns within a short time. ",
        iconClass: "ti-files",
      },
      {
        id: 4,
        heading: "Export CSV File",
        content:
          "You can export CSV files with customer's information, preview link, design link( png, jpg ) and custom text.",
        iconClass: "ti-share",
      },
    ],
  };

  // componentDidMount() {
  //   axios
  //     .get(`${BASE_URL}`)
  //     .then((res) => {
  //       this.setState({
  //         data: res.data.promoData,
  //       });
  //       // console.log(this.state.data);
  //     })
  //     .catch((err) => console.log(err));
  // }

  render() {
    return (
      <div>
        {/* start promo section */}
        <section className="promo-section ptb-90">
          <div className="promo-section-wrap">
            <div className="container">
              <div className="row">
                {this.state.data.map((item, idx) => {
                  return (
                    <div key={`s_${idx}`} className="col-md-3 col-sm-6">
                      <div className="bg-secondary single-promo-section text-center">
                        <div className="single-promo-content">
                          <span className={item.iconClass}></span>
                          <h6>{item.heading}</h6>
                          <p>{item.content}</p>
                        </div>
                        <div className="line"></div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          </div>
        </section>
        {/* end promo section */}
      </div>
    );
  }
}

export default PromoSection;
